import * as React from "react";
/**
 * Observe the node for mutations.
 *
 * This is similar to a rooks / react-hooks-org hook, but has a few differences we need:
 * - We are correctly typed to Node, vs rooks too-strict HTMLElement
 * - A node is accepted directly rather than a ref, allowing us to handle changes to the node.
 *
 * @param node The node to observe
 * @param handler The handler to handle mutations
 * @param when If specified, only observe when true
 */
export function useMutationObserver(node, handler, when) {
    if (when === void 0) { when = true; }
    var handlerRef = React.useRef(handler);
    React.useEffect(function () {
        handlerRef.current = handler;
    });
    React.useEffect(function () {
        if (node && when) {
            var observer_1 = new MutationObserver(function () { return handlerRef.current(); });
            observer_1.observe(node, {
                attributes: true,
                characterData: true,
                childList: true,
                subtree: true
            });
            return function () { return observer_1.disconnect(); };
        }
    }, [node, when]);
}
//# sourceMappingURL=useMutationObserver.js.map